import React, {useEffect, useState} from "react";
import {IconButton, Snackbar, Stack, Box} from "@mui/material";
import styles from "./Notification.module.css"
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import {NotificationService} from "../service/service";
import {NotificationInfo} from "../models/Notification";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
interface NotificationProps {
    children?: React.ReactNode;
}

export function Notification({children}: NotificationProps) {
    const [info, setInfo] = useState<NotificationInfo | undefined>();
    const [isOpen, setOpen] = useState<boolean>(false);

    useEffect(() => {
        NotificationService.getInstance().subscribe(e => {
            setInfo(e);
            setOpen(true)
        });
    }, [])

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    function getStyle(type: 'alert' | 'info' | 'error' | 'success' | undefined): string {
        switch (type) {
            case 'error':
                return styles.error;
            case 'info':
                return styles.info;
            case 'alert':
                return styles.alert;
            case 'success':
                return styles.success;
        }
        return '';
    }

    function getIcon(type: 'alert' | 'info' | 'error' | 'success' | undefined): any {
        switch (type) {
            case 'error':
                return <CloseIcon/>;
            case 'info':
                return <InfoIcon/>;
            case 'alert':
                return <NotificationsActiveIcon/>;
            case 'success':
                return <ThumbUpAltIcon/>;
        }
        return undefined;
    }

    return (
        <div>
            {children}
            <Snackbar open={isOpen} autoHideDuration={6000} onClose={handleClose}
                      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}>
                <Box className={`${styles.general} ${getStyle(info?.type)}`}>
                    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                        <Stack direction={'row'} spacing={1}>
                            {getIcon(info?.type)}
                            <div className={styles.header}>{info?.header}</div>
                        </Stack>
                        <IconButton onClick={handleClose}>
                            <CloseIcon className={styles.closeBtn}/>
                        </IconButton>
                    </Stack>
                    <div className={styles.desc}>{info?.text}</div>
                </Box>
            </Snackbar>
        </div>
    );
}
